import { cache } from "react";
import { fetchData } from "@repo/shared-utils/fetch-utils";
import { LogUtils } from "@repo/shared-utils/log-utils";
import { TradingMallApiEndpoints } from "../constants/TradingMallApiEndpoints";
import { ITradingMallContent } from "../interfaces/ITradingMallContentV1.interface";

/**
 * Fetches AEM headless content for trading-mall pages.
 * Wrapped with React `cache()` so generateMetadata + page.tsx share one
 * network call per server request (same appVersion + endpointKey).
 */
async function fetchTradingMallContentV1(
  appVersion: string,
  endpointKey: keyof typeof TradingMallApiEndpoints = "TRADING_MALL_CONTENT",
): Promise<ITradingMallContent> {
  const endpoint = TradingMallApiEndpoints[endpointKey].replace(
    "{version}",
    appVersion,
  );
  const response: ITradingMallContent = await fetchData({
    endpoint,
    tags: ["TradingMallContent", `TradingMallContent${appVersion}`],
    cache: "force-cache",
  });
  LogUtils.debug("getTradingMallContentV1: ", response);
  return response;
}

export const getTradingMallContentV1 = cache(fetchTradingMallContentV1);
